// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__kHjg2","boxTitle":"Qualiphy_boxTitle__-oz3h","box":"Qualiphy_box__3ghf8","toggleWrap":"Qualiphy_toggleWrap__2KuxZ"};